<template>
  <v-card class="d-flex flex-column align-center justify-center elevation-0 py-16" width="100%" outlined>
    <img :src="InputMarkImage" />
    <span class="mt-4">
      Vui lòng cung cấp các thông tin ở trên, sau đó ấn [{{ content ? content : 'Xác nhận' }}] để lấy danh sách
    </span>
  </v-card>
</template>

<script>
import MarkImage from '@/assets/mark-view-icon.svg'
import InputMarkImage from '@/assets/mark-input-icon.svg'

export default {
  components: {},
  props: {
    content: String,
  },
  data() {
    return {
      MarkImage,
      InputMarkImage,
    }
  },
  computed: {},
}
</script>

<style></style>
